<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration Step 5 of 6
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <jet-form-section @submitted="saveProgress">
                    <template #title>
                        Example Messages
                    </template>

                    <template #form>
                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div class="mb-2">
                                    Please write example messages that best match the type of messages you will be sending <span class="required">*</span>
                                    <div class="font-light italic">20 character minimum length</div>
                                </div>
                                Examples:
                                <div class="font-light text-gray-600">
                                    <div v-for="(example, index) in exampleMessages" :key="index">
                                        {{ example }}
                                    </div>
                                    
                                </div>
                            </label>

                            <jet-input
                                class="mt-2 mr-2 block w-full"
                                placeholder="Example #1"
                                v-model="form.example_messages.custom1"
                            />

                            <jet-input
                                class="mt-2 mr-2 block w-full"
                                placeholder="Example #2"
                                v-model="form.example_messages.custom2"
                            />

                            <jet-input
                                class="mt-2 mr-2 block w-full"
                                placeholder="Example #3"
                                v-model="form.example_messages.custom3"
                            />

                        </div>

                        

                    </template>
                    <template #actions>
                        <Link :href="route('a2p.step4')" class="mr-auto" >
                            <jet-button secondary type="button">
                                Back
                            </jet-button>
                        </Link>

                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="!goodToContinue"
                        >
                            Next
                        </jet-button>
                    </template>
                </jet-form-section>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import exampleSelectable from "../../components/A2p/ExampleSelectable";



export default {
    name: 'A2P-Step5',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        exampleSelectable,
    },
    data() {
        return {
            form: this.$inertia.form(
                {
                    _method: "POST",
                    example_messages: {
                        custom1: this.$page.props.a2p.example_messages['custom1'],
                        custom2: this.$page.props.a2p.example_messages['custom2'],
                        custom3: this.$page.props.a2p.example_messages['custom3'],
                    },
                    
                    step: 5,
                },
                {
                }
            ),
            exampleMessages: [
                "Reminder, your appointment is scheduled for tomorrow at 1 pm.",
                "We are having a 20% off everything sale this weekend only.",
                "Our event start time has changed from 5pm to 6pm.",
                "Thank you for requesting a meeting. A member of our team will be in touch shortly.",
            ]
        }
    },
    computed: {
        goodToContinue() {
            return (
                this.form.example_messages['custom1'] &&
                this.form.example_messages['custom2'] &&
                this.form.example_messages['custom1'].length >= 20 &&
                this.form.example_messages['custom2'].length >= 20 &&
                (!this.form.example_messages['custom3'] || (this.form.example_messages['custom3'].length == 0 || this.form.example_messages['custom3'].length >=20))
            );
        },
       
    },
    mounted() {

    },
    methods: {
        saveProgress() {

            this.form.post("/verified/save-progress", {
                preserveScroll: true,
                onSuccess: (response) => {
                    
                },
            });
        },
    },
    watch: {
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
